import * as apiNote from '@/api/note'

import store from '@/store'

const getDefaultState = () => {
  const defaults = {
    share_type: 1,
    share_classification: null,
    // ログインユーザーと同じ契約に属する全利用者リスト(ノート権限リスト)
    userPermissions: [],
    // 共有利用者リスト{id:ユーザーID, type:共有区分}の形式
    share_users: [],
    // 現在選択中(未確定)の共有(閲覧可)利用者リスト
    shareUsersViewable: [],
    // 現在選択中(未確定)の共有(編集可)利用者リスト
    shareUsersEditable: [],
    loading: {
      user_permissions: false
    }
  }
  return defaults
}

const noteSelect = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    userPermissions: (state) => state.userPermissions,
    shareUsersViewable: (state) => state.shareUsersViewable,
    shareUsersEditable: (state) => state.shareUsersEditable
  },
  mutations: {
    resetAllState(state) {
      Object.assign(state, getDefaultState())
    },
    setShareType(state, shareType) {
      state.share_type = shareType
    },
    setShareClassification(state, shareClassification) {
      state.share_classification = shareClassification
    },
    setUserPermissions: (state, userPermissions) => {
      state.userPermissions = userPermissions
    },
    setShareUsers: (state, shareUsers) => {
      state.share_users = shareUsers
    },
    // 現在選択中(未確定)の共有(閲覧可)利用者リスト
    setShareUsersViewable(state, shareUsersViewable) {
      state.shareUsersViewable = shareUsersViewable
    },
    // 現在選択中(未確定)の共有(編集可)利用者リスト
    setShareUsersEditable(state, shareUsersEditable) {
      state.shareUsersEditable = shareUsersEditable
    },
    loadingUserPermissions(state, flg) {
      state.loading.user_permissions = flg
    }
  },
  actions: {
    resetAllState: ({ commit }) => {
      commit('resetAllState')
    },
    setShareType({ commit }, shareType) {
      commit('setShareType', shareType)
    },
    setShareClassification({ commit }, shareClassification) {
      commit('setShareClassification', shareClassification)
    },
    setShareUsers({ commit }, shareUsers) {
      commit('setShareUsers', shareUsers)
    },
    // 現在選択中(未確定)の共有(閲覧可)利用者リスト
    setShareUsersViewable({ commit }, shareUsersViewable) {
      commit('setShareUsersViewable', shareUsersViewable)
    },
    // 現在選択中(未確定)の共有(編集可)利用者リスト
    setShareUsersEditable({ commit }, shareUsersEditable) {
      commit('setShareUsersEditable', shareUsersEditable)
    },
    /**
     * ノート利用者権限一覧を取得
     * @param {*} param0 
     * @param {*} isShareUsersSet DBに保存されている選択ユーザーをshare_usersを設定する場合はtrue
     */
    getUserPermissions: async ({ commit, state }, { isShareUsersSet }) => {

      commit('loadingUserPermissions', true)

      // ノート利用者権限一覧APIをコール
      const params = {}
      await apiNote
        .getUserPermissions(params)
        .then(response => {
          const { data } = response

          if (data.status === 0) {
            const users = data.users

            const userPermissions = []
            const shareUsers = []
            const shareUsersViewable = []
            const shareUsersEditable = []
            for (let i = 0; i < users.length; i++) {
              // APIレスポンスでは integrated_user_id が使われているため、id にマッピング
              const id = users[i].integrated_user_id || users[i].id
              const type = users[i].share_classification

              // 【注意】ここで自分(ログインユーザー)を除外する処理はしない。
              // ・編集権限ユーザーの場合に権限が外れたり、
              //   「保存」ボタンのアクティブ判定が正常にできなくなるため。
              // ・画面に自分(ログインユーザー)を含めない処理はビュー側で行う

              // id プロパティを追加して userPermissions に push
              const userPermission = {
                ...users[i],
                id: id
              }
              userPermissions.push(userPermission)

              const map = {
                id: id,
                type: type
              }
              if (type === 21) {
                // 閲覧可の場合
                shareUsers.push(map)
                shareUsersViewable.push(map)
              } else if (type === 22) {
                // 編集可の場合
                shareUsers.push(map)
                shareUsersEditable.push(map)
              }
            }

            commit('setUserPermissions', userPermissions)

            if (isShareUsersSet) {
              commit('setShareUsersViewable', shareUsersViewable)
              commit('setShareUsersEditable', shareUsersEditable)
            }
          }
        })
        .finally(() => {
          commit('loadingUserPermissions', false)
        })
    },
    resetUserPermissions: ({ commit }) => {
      commit('setUserPermissions', [])
    },
    resetShareUsers: ({ commit }) => {
      commit('setShareUsers', [])
      commit('setShareUsersViewable', [])
      commit('setShareUsersEditable', [])
    }
  }
}

export default noteSelect
